// extracted by mini-css-extract-plugin
export var brand = "_1j-9";
export var button = "_1j-0";
export var chevron = "_1j-v";
export var chevronButton = "_1j-w";
export var content = "_1j-n";
export var danger = "_1j-g";
export var dangerOutlined = "_1j-h";
export var dark = "_1j-l";
export var darkTheme = "_1j-c";
export var extraSmall = "_1j-4";
export var fullWidth = "_1j-8";
export var ghost = "_1j-d";
export var gray = "_1j-t";
export var icon = "_1j-p";
export var iconButton = "_1j-s";
export var iconButtonBorder = "_1j-x";
export var iconButtonBorderDark = "_1j-y";
export var iconButtonBorderLight = "_1j-z";
export var iconLeft = "_1j-q";
export var iconRight = "_1j-r";
export var large = "_1j-1";
export var light = "_1j-m";
export var medium = "_1j-2";
export var micro = "_1j-5";
export var nano = "_1j-7";
export var outlined = "_1j-k";
export var pending = "_1j-a";
export var primary = "_1j-i";
export var shadow = "_1j-o";
export var small = "_1j-3";
export var solidLight = "_1j-e";
export var solidLightBrand = "_1j-f";
export var spinner = "_1j-u";
export var transparent = "_1j-j";
export var warning = "_1j-b";
export var wideNano = "_1j-6";